import { render, staticRenderFns } from "./Page-SettingsMobile.vue?vue&type=template&id=2508b046"
import script from "./Page-SettingsMobile.vue?vue&type=script&lang=js"
export * from "./Page-SettingsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports